import * as React from "react";
import { History, User } from "lucide-react";
import { useImpersonationDialogContext } from "../ImpersonationContext";
import { UserListItem } from "./UserListItem";
import { SkeletonList } from "./SkeletonList";

export const UserList: React.FC = () => {
  const { scrollContainerRef, handleScroll, search, recentUsers, focusedIndex, isLoading, users } =
    useImpersonationDialogContext();

  return (
    <div ref={scrollContainerRef} onScroll={handleScroll} className="flex-1 overflow-y-auto p-3 bg-slate-50/30">
      {!search && recentUsers.length > 0 && (
        <div className="mb-4">
          <h4 className="px-4 py-1.5 text-[10px] font-bold text-slate-400 uppercase tracking-wider flex items-center gap-1.5">
            <History className="h-3 w-3" />
            Recently Viewed
          </h4>
          <div className="space-y-0.5">
            {recentUsers.map((user, idx) => {
              const isFocused = idx === focusedIndex;
              return <UserListItem key={`recent-${user.guid}`} user={user} isFocused={isFocused} isRecent={true} />;
            })}
          </div>
        </div>
      )}

      <div>
        <h4 className="px-4 py-1.5 text-[10px] font-bold text-slate-400 uppercase tracking-wider">
          {search ? "Search Results" : "Suggested Users"}
        </h4>

        {isLoading ? (
          <SkeletonList />
        ) : (
          <div className="space-y-0.5">
            {users.length > 0 ? (
              users.map((user, idx) => {
                // Offset focus index if recent users are also rendered
                const adjustedIdx = !search && recentUsers.length > 0 ? idx + recentUsers.length : idx;
                const isFocused = adjustedIdx === focusedIndex;
                return <UserListItem key={`user-${user.guid}`} user={user} isFocused={isFocused} isRecent={false} />;
              })
            ) : (
              <div className="text-center py-12 text-slate-400">
                <User className="h-12 w-12 mx-auto mb-3 opacity-20" />
                <p className="text-sm">No users found matching your search</p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
